import React from "react";
import {currencyFormatNoDecimals, AppliesToFriendlyNames, SOURCES} from "../../shared/shared";
import {NONQUAL_ACCOUNTS, PRETAX_ACCOUNTS, TAXFREE_ACCOUNTS} from "../../shared/constants";

export const Accounts = (props) => {
    const financialDataItemTHStyle = {
        padding: "0.5em"
    };
    const financialDataItemTDStyle = {
        padding: "0.5em",
        fontSize: "0.9em",
        textAlign: "center"
    };
    const financialDataItemStyle = {
        display: "inline-block",
        width: "150px",
        marginRight: "1em"
    };
    const financialDataItemLabelStyle = {
        display: "inline-block",
        marginRight: "1em"
    };
    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }
    const displayAccountTypeLabel = (dataItem) => {
        const options =
            (dataItem.taxType === "NON_QUALIFIED"
                ? NONQUAL_ACCOUNTS
                : dataItem.taxType === "PRE_TAX"
                    ? PRETAX_ACCOUNTS
                    : TAXFREE_ACCOUNTS).map(item => {
                let label = item.text;
                if (item.value === "TE_OTHER" && dataItem.accountTypeOtherName) {
                    label = dataItem.accountTypeOtherName;
                }
                return {
                    ...item,
                    text: label,
                }
            });
        const selectedOption = options.find((c) => c.value === dataItem.accountType);
        return selectedOption.text;
    };

    return (<div>
        <h2 style={subSectionStyle}> Savings And Contributions</h2>
        <table style={{
            width: "100%",
            borderCollapse: "collapse"
        }}>
            <thead>
                <tr style={{
                    backgroundColor: "#157ee8",
                    color: "white",
                }}>
                    <th style={financialDataItemTHStyle}>Tax type</th>
                    <th style={financialDataItemTHStyle}>Account Type</th>
                    <th style={financialDataItemTHStyle}>Owner</th>
                    <th style={financialDataItemTHStyle}>Acct Value</th>
                    <th style={financialDataItemTHStyle}>Cost Basis</th>
                    <th style={financialDataItemTHStyle}>Stocks</th>
                    <th style={financialDataItemTHStyle}>Bonds</th>
                    <th style={financialDataItemTHStyle}>Cash</th>
                </tr>
            </thead>
            <tbody>
                {props?.accounts?.length > 0 && (
                    props.accounts.map((item, idx) => {
                        return <React.Fragment key={idx}><tr>
                            <td style={financialDataItemTDStyle}>{item.taxType.replaceAll("_", " ")}</td>
                            <td style={financialDataItemTDStyle}>{displayAccountTypeLabel(item)}</td>
                            <td style={financialDataItemTDStyle}>
                                {AppliesToFriendlyNames[item.appliesTo]}&nbsp;
                                {item.appliesTo === "TRUST" && <span>{item.trustName}</span>}
                            </td>
                            <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.value)}</td>
                            <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.costBasis)}</td>
                            <td style={financialDataItemTDStyle}>{item.stocks.toFixed(0)}%</td>
                            <td style={financialDataItemTDStyle}>{item.bonds.toFixed(0)}%</td>
                            <td style={financialDataItemTDStyle}>{item.cash.toFixed(0)}%</td>
                        </tr>
                            <tr style={{
                                borderBottom: "1px solid #eee"
                            }}>
                                <td colSpan={8} style={{
                                    padding: "0.5em",
                                    fontSize: "0.7em"
                                }}>
                                    <div style={financialDataItemStyle}>
                                        <label style={financialDataItemLabelStyle}>Frequency</label>
                                        <span>{item.contributions?.frequency}</span>
                                    </div>
                                    <div style={financialDataItemStyle}>
                                        <label style={financialDataItemLabelStyle}>Source</label>
                                        <span>{SOURCES[item.contributions?.contributionSourceType]}</span>
                                    </div>
                                    <div style={financialDataItemStyle}>
                                        <label style={financialDataItemLabelStyle}>Amount</label>
                                        <span>{currencyFormatNoDecimals(item.contributions?.amount)}</span>
                                    </div>
                                    <div style={financialDataItemStyle}>
                                        <label style={financialDataItemLabelStyle}>Start Year</label>
                                        <span>{item.contributions?.startYear}</span>
                                    </div>
                                    <div style={financialDataItemStyle}>
                                        <label style={financialDataItemLabelStyle}>End Year</label>
                                        <span>{item.contributions?.endYear}</span>
                                    </div>
                                </td>
                            </tr></React.Fragment>
                    }))}
            </tbody>
        </table>
    </div>)

}
